import { useCallback } from 'react';
import type { SupportedPermissions } from './SupportedPermissions.tsx';
import { selectHasPermissions } from './useHasPermissions.tsx';
import { usePermissions } from './PermissionsContainer.tsx';

export const useGetHasPermissionCallback: (
	permissionKeys: SupportedPermissions[],
) => (projectId: string | undefined) => boolean = (permissionKeys: SupportedPermissions[]) => {
	const [permissionsState] = usePermissions();

	return useCallback(
		(projectId: string | undefined): boolean =>
			projectId !== undefined &&
			selectHasPermissions(permissionsState, {
				permissionKeys,
				projectIds: [projectId],
				permissionsMatch: 'all',
			}),
		[permissionsState, permissionKeys],
	);
};
